<template>
  <div id="app">
    <!-- 描画開始 -->
    <template v-if="state === 'rendering'">
      <ItemDialog ref="notAuth" image-type="loader" :initial-open="true">
        <template #content-area>
          <h2>{{ $t("common.loading") }}</h2>
          <!-- <p>route: {{route}}</p>
          <p>device: {{device}}</p>
          <p>idtoken: {{idToken}}</p>
          <p>accesstoken: {{accessToken}}</p> -->
        </template>
      </ItemDialog>
    </template>

    <!-- 認証情報取得成功 -->
    <template v-else-if="state === 'mounted'">
      <router-view :key="componentKey" />
    </template>

    <!-- 認証情報取得失敗 -->
    <!-- scriptの処理で、ネイティブのダイアログを表示する -->
    <template v-else />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  name: "App",
  data() {
    return {
      route: this.$route.name,
      state: "rendering",
      dontCheckTokenViewList: [
        "MasterBook",
        "TicketStoreIndex",
        "RecommendationIndex",
        "MyTicketsIndex",
        "MyTicketsIndexOfPast",
        "MyCouponsIndex",
        "MyCouponsIndexOfPast",
        "MfittIndex",
        "MfittBooking1", // ログイン必要な画面だが、経路検索開いた際、iOSで真っ白になるので、描画後にダイアログを出す
        "DbsIndex",
        "DbsBookingConfirmation", //  ログイン必要な画面だが、QRから開いた際に真っ白になるので、描画後にダイアログ出す
        "CarShareIndex",
        "DemandIndex",
        "RentalCarIndex",
        "SetQR",
      ],
      blankPageList: [
        "MfittBooking1",
        "MfittSelectCoupon",
        "MfittSelectPaymentMethod",
        "MfittBooking4",
        "SheetValid",
        "MfittBookingConfirmation",
      ],
      componentKey: 0,
    };
  },
  errorCaptured(err, vm, info) {
    if (
      process.env.VUE_APP_ENV == "development" ||
      process.env.VUE_APP_ENV == "staging"
    ) {
      if (vm._.components) {
        window.prompt(
          "errorCaptured by " + vm._.components.name,
          "Error: " + err.toString() + ", Info: " + info
        );
      } else if (vm._.setup) {
        window.prompt(
          "errorCaptured by " + vm._.setup.__file,
          "Error: " + err.toString() + ", Info: " + info
        );
      }
    }
  },
  created() {
    // 言語設定(クエリパラメータに指定がない、または不正な場合はデフォルトの言語に設定される)
    const availableLanguages = ["ja", "en"];

    // ネイティブから渡ってくる言語パラメータは２種
    let lang = "";
    if (this.$route.query.lang) {
      lang = this.$route.query.lang;
    } else if (this.$route.query.language) {
      lang = this.$route.query.language;
    }

    lang = availableLanguages.includes(lang) ? lang : "ja";
    this.$i18n.locale = lang;
    this.setLang(lang);
  },
  async mounted() {
    await this.getDevice();

    var getTokenInterval = setInterval(() => {
      console.log("interval");
      if (this.idToken === null || this.idToken.length == 0) {
        console.log("getTokens");
        this.getTokens();
        clearInterval(getTokenInterval);
      }
    }, 100);
  },
  computed: {
    ...mapGetters("common", [
      "device",
      "idToken",
      "accessToken",
      "isReloadComponent",
    ]),
  },
  watch: {
    // idTokenとaccessTokenの両方がセットされたタイミングでsetTokenDoneメソッドを発火させる
    idToken(value) {
      if (typeof value === "string" && typeof this.accessToken === "string") {
        this.setTokenDone();
      }
    },
    // idTokenとaccessTokenの両方がセットされたタイミングでsetTokenDoneメソッドを発火させる
    accessToken(value) {
      if (typeof this.idToken === "string" && typeof value === "string") {
        this.setTokenDone();
      }
    },
    state(value) {
      if (value === "noToken") {
        // 未ログインの場合、ネイティブのダイアログを表示する
        this.returnNativeAppToAccountPage();
      }
    },
    isReloadComponent(value) {
      if (value) {
        if (this.blankPageList.includes(this.$route.name)) {
          this.componentKey += 1;
          this.setIsReloadComponent(null);
        }
      }
    },
  },
  methods: {
    setTokenDone() {
      var isGetTokenSuccess = false;
      if (this.dontCheckTokenViewList.includes(this.$route.name)) {
        // ログインをチェックしないViewの場合は必ず返却されるidTokenの値だけ見て返す
        isGetTokenSuccess = this.hasIdToken;
      } else {
        // ログインをチェックするViewの場合は、両トークンに値が入ることを確認する
        isGetTokenSuccess = this.isLogin;
      }
      this.state = isGetTokenSuccess ? "mounted" : "noToken";
    },
    ...mapMutations("common", [
      "setIdToken",
      "setAccessToken",
      "setLang",
      "setIsReloadComponent",
    ]),
  },
};
</script>

<style lang="scss"></style>
